export default {"src":"/komodo/_next/static/media/gleec-logo-dark.d7a1fdb9.svg","height":36,"width":145,"blurWidth":0,"blurHeight":0};